export default __webpack_public_path__ + "static/media/prm-club-desktop.198c55d2.png";